export const isZipCodeValid = (value?: string): boolean => {
	if (!value) {
		return true;
	}

	return /^([0-9]{3}\s?[0-9]{2})$/.test(value);
};
